import { Colors, iconNames } from '@zapier/design-system';
export const comparisonTableConfig = {
    name: 'ComparisonTable',
    category: 'Zapier Sections',
    includeScrollTracking: true,
    inputs: [
        {
            name: 'title',
            type: 'string',
        },
        {
            name: 'leftColumnMinWidth',
            type: 'number',
            helperText: 'Minimum width of the left column in pixels. Should be used if the left column text is long and wraps to multiple lines and other cells only contain small-width content like icons.',
        },
        {
            name: 'columns',
            type: 'list',
            subFields: [
                {
                    name: 'header',
                    type: 'string',
                },
                {
                    name: 'isDefaultLeftColumn',
                    friendlyName: 'Default left column on mobile',
                    type: 'boolean',
                },
                {
                    name: 'isDefaultRightColumn',
                    friendlyName: 'Default right column on mobile',
                    type: 'boolean',
                },
            ],
        },
        {
            name: 'groups',
            type: 'list',
            subFields: [
                {
                    name: 'title',
                    type: 'string',
                },
                {
                    name: 'rows',
                    type: 'list',
                    subFields: [
                        {
                            name: 'header',
                            type: 'string',
                        },
                        {
                            name: 'tooltip',
                            type: 'richText',
                        },
                        {
                            name: 'tagLabelText',
                            type: 'string',
                        },
                        {
                            name: 'tagLabelColor',
                            type: 'string',
                            enum: ['', ...Object.keys(Colors)],
                        },
                        {
                            name: 'cells',
                            type: 'list',
                            subFields: [
                                {
                                    name: 'text',
                                    type: 'longText',
                                },
                                {
                                    name: 'icon',
                                    type: 'string',
                                    enum: ['', 'formDash', 'formCheck'],
                                },
                                {
                                    name: 'backgroundColor',
                                    type: 'string',
                                    enum: ['', ...Object.keys(Colors)],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        { name: 'hasExpansionButton', type: 'boolean' },
        {
            name: 'expansionButtonConfig',
            type: 'object',
            showIf: (options) => options.get('hasExpansionButton'),
            subFields: [
                {
                    name: 'seeMoreText',
                    type: 'string',
                    required: true,
                },
                {
                    name: 'seeMoreIcon',
                    type: 'string',
                    enum: ['', ...Object.keys(iconNames)],
                },
                {
                    name: 'seeLessText',
                    type: 'string',
                },
                {
                    name: 'seeLessIcon',
                    type: 'string',
                    enum: ['', ...Object.keys(iconNames)],
                },
                {
                    name: 'color',
                    type: 'string',
                    enum: ['danger', 'primary', 'primary-alt', 'secondary', 'tertiary'],
                    required: true,
                },
                {
                    name: 'groupsOpenByDefault',
                    helperText: 'Number of groups that are open when the table is first rendered.',
                    type: 'number',
                    required: true,
                },
            ],
            defaultValue: {
                seeMoreText: 'See more features',
                seeMoreIcon: 'formAdd',
                seeLessText: 'See less features',
                seeLessIcon: 'formDash',
                color: 'secondary',
                groupsOpenByDefault: 1,
            },
        },
    ],
};
//# sourceMappingURL=config.js.map